import { Flex } from 'antd';
import React, { useEffect, useState } from 'react';
import { useRelayEnvironment } from 'react-relay';

import { WIDTH_CARD_TASK_SMALL } from '../const';
import { getObjectFromRelayStoreById } from '../functions';
import { ListItemType, SubTaskType, TaskPositionType } from '../types';
import { defaultIconTaskType, getIconByPriorityTask, getTaskTypeIcon } from './calendarFunctions';
import { defaultDataConfig } from './data/defaultDataConfig';

interface ICalendarTaskBodyStatusesLine {
    task: TaskPositionType;
    widthTaskBody: number;
}

const CalendarTaskBodyStatusesLine: React.FC<ICalendarTaskBodyStatusesLine> = ({ task, widthTaskBody }) => {
    const environment = useRelayEnvironment();
    const subTaskList = task.subtask ? JSON.parse(task.subtask) : [];
    const gap = widthTaskBody > WIDTH_CARD_TASK_SMALL ? 10 : 5;

    const totalSubTask = subTaskList.length;
    const doneSubTask = subTaskList.filter((subTask: SubTaskType) => subTask.status).length;
    const [iconListItem, setIconListItem] = useState<ListItemType | null>(null);

    useEffect(() => {
        if (task && task.type) {
            const dataTaskType = defaultDataConfig[task.type!];
            const iconId = dataTaskType ? dataTaskType.iconId.toString() : null;
            const iconData = iconId ? getObjectFromRelayStoreById<ListItemType>(environment, iconId) : null;

            if (iconData) {
                setIconListItem(iconData);
            } else {
                setIconListItem(null);
            }
        }
    }, [task]);

    return (
        <Flex gap={gap} style={{ fontSize: 12, zIndex: 1000 }} align={'center'}>
            <div>{iconListItem ? getTaskTypeIcon(iconListItem.id.toString(), 16) : defaultIconTaskType()}</div>
            <div>{getIconByPriorityTask(task.priority!)}</div>
            <div>
                {doneSubTask}/{totalSubTask}
            </div>
        </Flex>
    );
};

export default CalendarTaskBodyStatusesLine;
